<template>
    <button
        v-tippy="t('editorToggleHeader6')"
        :class="[
            buttonState(
                editor.can().toggleHeading({ level: 6 }),
                editor.isActive('heading', { level: 6 }),
            ),
            'flex-none rounded p-1 text-sm',
        ]"
        :disabled="!editor.can().toggleHeading({ level: 6 })"
        @click="editor.chain().focus().toggleHeading({ level: 6 }).run()"
    >
        <MdiFormatHeader6 class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiFormatHeader6 from 'materialdesignicons-vue3/icons/MdiFormatHeader6.js';

    defineExpose({
        name: 'FormatHeader6Button',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
